import { Link } from "react-router-dom";
import { Heart, Mail, Building2, HandCoins, ExternalLink } from "lucide-react";
import PageLayout from "../components/site/PageLayout";
import { Reveal } from "../components/site/Reveal";
import { SectionHeading } from "../components/site/SectionHeading";
import { Button } from "../components/ui/button";
import { useContent } from "../lib/content";

const ICONS = { heart: Heart, mail: Mail, building: Building2, hand: HandCoins };

const Donate = () => {
  const { content } = useContent();
  const d = content.donations;
  return (
    <PageLayout title="Donate">
      <section className="relative pt-16 pb-10 overflow-hidden">
        <div className="ambient" aria-hidden />
        <div className="ambient-grid" aria-hidden />
        <div className="container-tt grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <SectionHeading eyebrow="Donate" title={d.title} description={d.body} />
            <div className="mt-8 flex flex-wrap gap-3">
              {d.primaryCta?.href && (
                <Button asChild className="btn-pill btn-motion btn-sky-fill h-14 px-8 text-white text-base shadow-sky hover:shadow-skyHover border-0">
                  <a href={d.primaryCta.href} target="_blank" rel="noreferrer" data-testid="donate-primary-cta">{d.primaryCta.label} <ExternalLink size={16} className="ml-2" /></a>
                </Button>
              )}
              <Button asChild variant="outline" className="btn-pill btn-motion h-14 px-8 border-stone/15 bg-white/70 text-stone hover:bg-stone hover:border-stone hover:text-white text-base">
                <Link to="/contact">Contact us</Link>
              </Button>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="relative rounded-[2rem] btn-sky-fill text-white p-10 overflow-hidden shadow-skyHover ring-1 ring-white/25 grain">
              <div className="absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-white/15 blur-2xl" aria-hidden />
              <Heart size={40} className="relative" />
              <div className="relative font-display text-3xl mt-6 leading-tight text-shadow-soft">{d.callout}</div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container-tt">
          <SectionHeading eyebrow="How to give" title="Ways to support TechTies." />
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="donation-methods">
            {d.methods.map((m, i) => {
              const Icon = ICONS[m.icon] || Heart;
              return (
                <Reveal key={m.title} delay={i * 0.05}>
                  <div className="card-surface card-lift p-8 h-full">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-accent/70 border border-sky/15 text-skyDark"><Icon size={22} /></div>
                    <div className="font-display text-2xl mt-6 text-stone">{m.title}</div>
                    <p className="mt-3 text-stone/80 leading-relaxed">{m.description}</p>
                    {m.actionLabel && (
                      <div className="mt-5">
                        {m.actionHref ? (
                          <a href={m.actionHref} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-1.5 text-skyDark font-medium">
                            {m.actionLabel} <ExternalLink size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                          </a>
                        ) : (
                          <span className="text-sm text-muted-foreground italic">{m.actionLabel}</span>
                        )}
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Donate;
